module.exports = __webpack_public_path__ + "static/media/38.b2ea03ea.png";